import React from 'react'
import { Spinner } from '@wellbeingxltd/fe-lib/components'
import { PERMITIONS_KEYS, SUPPLIERS_PERMISSIONS_TO_VIEW } from '@wellbeingxltd/fe-lib/constants'
import { TickIcon } from 'components'
import { notifications } from './config'

const Permission = ({ permission, value, isManager, loadingUpdateRole, updateRole, keyValue, updatedPermissions, columnWithPermissions }) => {
    const id = `${permission}_${value.email}`
    const updatedPermission = updatedPermissions[id]
    const updatedPermissionKey = updatedPermission?.body && Object.keys(updatedPermission?.body)?.[0]

    const label =
        keyValue === PERMITIONS_KEYS.EMAIL_NOTIFICATION
            ? notifications.find(({ value }) => value === permission).label
            : keyValue === PERMITIONS_KEYS.PERMITION_TO_VIEW
            ? SUPPLIERS_PERMISSIONS_TO_VIEW[permission]?.label
            : ''

    let isCheckIconVisible = value?.email === updatedPermission?.email && permission === updatedPermissionKey
    const isLoadingIconVisible =
        loadingUpdateRole?.email === value.email && loadingUpdateRole?.property === permission && loadingUpdateRole?.key === keyValue

    return (
        <div key={permission} className="admins-checkbox">
            <div className="inputBlock">
                {isLoadingIconVisible ? (
                    <Spinner color="var(--blue)" />
                ) : (
                    <input
                        type="checkbox"
                        id={id}
                        checked={columnWithPermissions[permission]}
                        onChange={e => updateRole({ [permission]: e.target.checked }, value.email, keyValue)}
                        disabled={isManager || !!loadingUpdateRole}
                    />
                )}
            </div>
            <label htmlFor={id}>{label}</label>
            <TickIcon isCheckIconVisible={isCheckIconVisible} />
        </div>
    )
}

export const Permissions = ({ value, loadingUpdateRole, updateRole, keyValue, updatedPermissions = {}, isManager = true }) => {
    const columnWithPermissions = value[keyValue]

    return columnWithPermissions ? (
        <div className="modal-managers-permissions">
            {Object.keys(columnWithPermissions).map(permission => (
                <Permission
                    key={permission}
                    {...{ permission, value, loadingUpdateRole, updateRole, keyValue, updatedPermissions, columnWithPermissions, isManager }}
                />
            ))}
        </div>
    ) : null
}
